import { render, staticRenderFns } from "./DocumentClaimsDetails.vue?vue&type=template&id=30439b92"
import script from "./DocumentClaimsDetails.vue?vue&type=script&lang=js"
export * from "./DocumentClaimsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports